export function coverageDetailAjax(){
    (function($) {
        function load_people(ruolo_id, competence_id, country_id, text_input){
            let window_size = $(window).width();
            let str ='&ruoloID=' + ruolo_id + '&competenceID=' + competence_id + '&countryID=' + country_id + '&action=coverage_people_filters';
            //console.log(str);
            $.ajax({
                url: ajax_carousel_posts.ajax_url, // La variabile ajax_url è fornita da WordPress
                type: 'post',
                data: {
                    action: 'coverage_people_filters',
                    ruoloID: ruolo_id,
                    competenceID: competence_id,
                    countryID: country_id,
                    windowSize: window_size,
                    textInput: text_input,
                },
                success: function(response) {
                    // Inserisci il contenuto della risposta nel tuo container desiderato
                    $('#ajax_peoples_container').html(response);
                    $('#ajax_content_coverage_people').owlCarousel({
                        loop:false,
                        items:1,
                        margin:5,
                        dots:true,
                        nav:false,
                        // Posiziona i puntini nel loro container
                        dotsContainer: '.custom-dots-container'
                    })
                    // Aggiungi manualmente i pulsanti 'prev' e 'next' nei rispettivi container
                    let owlInstance = $('#ajax_content_coverage_people').data('owl.carousel');
        
                    $('.coverage_peoples_block .custom-prev-container span').on('click', function () {
                        owlInstance.prev();
                    });
        
                    $('.coverage_peoples_block .custom-next-container span').on('click', function () {
                        owlInstance.next();
                    });

                    if($('.coverage_peoples_block .custom-dots-container').hasClass('disabled')){
                        $('.coverage_peoples_block .navs-container').hide();
                    }else{
                        $('.coverage_peoples_block .navs-container').show();
                    }
                },
                error: function(error) {
                    console.log(error);
                }
            });
            return false;
        }

        let country_id = $('input#country_id').val();
        load_people(null, null, country_id);

        $('#role_select').on('change', function(){
            let ruolo = $('#role_select').val();
            let country = $('#country_id').val();
            let competence = $('#competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

        $("#competence_area_select").on('change', function(){
            let ruolo = $('#role_select').val();
            let country = $('#country_id').val();
            let competence = $('#competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

        $("#custom_search_input_text").on('input', function(){
            let ruolo = $('#role_select').val();
            let country = $('#country_id').val();
            let competence = $('#people_competence_area_select').val();
            let text_input = $('#custom_search_input_text').val();
            load_people(ruolo, competence, country, text_input);
        })

    })(jQuery);
}